import { ADVISOR_NOTE_SEVERITY } from "@repo/database/advisor-constants";
import { advisorNoteWasDelivered } from "@repo/database/advisor-note-was-delivered";

import { out } from "../output/out";
import { truncate } from "@/lib/truncate/truncate";
import type { TranscriptEvent } from "@/lib/event/transcript-event";

/** Not the agent's words: the advisor watches the session from the outside. */
export function formatAdvisorPart(
  part: Extract<TranscriptEvent["part"], { kind: "advisor" }>,
): string {
  const note = truncate(part.text, 400);
  // The send, never the effect: queued steering waits for the agent's next turn.
  const delivery = advisorNoteWasDelivered(part)
    ? "sent to the agent"
    : "not delivered";
  switch (part.severity) {
    case ADVISOR_NOTE_SEVERITY.ALERT:
      return out.paint(`advisor alert, ${delivery}: ${note}`, "red");
    case ADVISOR_NOTE_SEVERITY.WARN:
      return out.paint(`advisor warning, ${delivery}: ${note}`, "yellow");
    case ADVISOR_NOTE_SEVERITY.SUGGESTION: {
      const named = part.skillName ? ` ${part.skillName}` : "";
      // "offered", not "sent": the agent decides whether to load the skill.
      const offer =
        delivery === "not delivered" ? delivery : "offered to the agent";
      return out.paint(
        `advisor skill suggestion${named}, ${offer}: ${note}`,
        "blue",
      );
    }
    case ADVISOR_NOTE_SEVERITY.NOTE:
      return out.paint(`advisor ${note}`, "dim");
    default:
      return part.severity satisfies never;
  }
}
